var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"contents"}},[(_vm.filterOptions.name === 'sharpen')?_c('FilterSharpen',{ref:"filter",attrs:{"amount":_vm.filterOptions.amount}}):_vm._e(),_c('div',{style:({
      filter: _vm.filterOptions.name !== 'none' ? ("url(#" + _vm.filterId + ")") : 'none',
    })},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }